import type { LogWriter, MessageOrError, Severity } from './logger.types';

export class GCPLogWriter implements LogWriter {
  write(
    severity: Severity,
    messageOrError: MessageOrError,
    metadata: Record<string, unknown> = {},
  ): void {
    try {
      const logFn = this.getLogFunction(severity);
      const logEntry = this.createStructuredLog(severity, messageOrError, metadata);
      logFn(JSON.stringify(logEntry));
    } catch (error) {
      console.error('Failed to write GCP structured log', {
        error,
        severity,
        messageOrError,
        metadata,
      });
    }
  }

  private getLogFunction(severity: Severity): (...args: unknown[]) => void {
    switch (severity) {
      case 'ERROR':
      case 'CRITICAL':
        return console.error;
      case 'WARNING':
        return console.warn;
      case 'DEBUG':
        return console.debug;
      default:
        return console.log;
    }
  }

  private createStructuredLog(
    severity: Severity,
    messageOrError: MessageOrError,
    metadata: Record<string, unknown>,
  ): Record<string, unknown> {
    return {
      severity,
      message: this.formatMessage(messageOrError),
      ...metadata,
    };
  }

  private formatMessage(input: MessageOrError): string {
    if (typeof input === 'string') return input;
    if (input instanceof Error) {
      return `${input.name}: ${input.message}\n${input.stack}`;
    }
    try {
      return JSON.stringify(input);
    } catch {
      return 'Unserializable message';
    }
  }
}
